import { convertToFormData } from "helper/convert_obj_to_form_data";
import client from "./config";

//////////////// blogs ////////////////
const url = "blogs/";
export const getBlogsRequest = (values) => {
  !values.search && delete values.search;
  return client.get(url, values);
};

export const getBlogByIdRequest = (values) => client.get(`${url}${values.id}`, values);

export const addNewBlogRequest = (values, onUploadProgress) => {
  return client.post(url, convertToFormData(values), {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    });
}

export const updateBlogByIdRequest = (values, onUploadProgress) => {
  return client.put(`${url}${values.id}`, convertToFormData(values), {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    });
}

export const deleteBlogByIdRequest = (values) => client.delete(`${url}${values}`);

export const deleteBlogFilesByIdRequest = (values) => client.put(`${url}${values.id}`, values);